import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {get, isEqual, unset} from 'lodash'

import AnswerOptions from './AnswerOptions'
import {graphingAnswerConfig, getLatex} from 'utils/ggb'
import analytic from 'utils/Analytic'


class Graphing extends Component {
    constructor(props) {
        super(props)
        this.uniq_id = 'challenge-component-graphing-' + Date.now() + '-' + Math.floor(Math.random() * 100)
        this.state = {
            answer_option: get(this.props.existing_answer, 'data.answer.answer_option', '')
        }
    }

    componentDidMount() {
        this.ggbInit()
    }

    componentDidUpdate(prevProps) {
        if (!isEqual(this.props.existing_answer, prevProps.existing_answer)) {
            if (this.props.is_preview) {
                const answer_option = get(this.props.existing_answer, 'data.answer.answer_option', '')
                this.setState({answer_option})

                if (answer_option === 'tool') {
                    const base64 = get(this.props.existing_answer, 'data.answer.base64', '')
                    this.graphing_instance.setBase64(base64)
                }
            }
        }
    }

    ggbInit() {
        const config = get(this.props.component_data, 'config', {})
        const ggb_config = {
            ...graphingAnswerConfig(this.uniq_id),
            appletOnLoad: (graphing_instance) => {
                this.graphing_instance = graphing_instance
            },
            ...config.ggb
        }

        // Clear customToolBar if material_id is set
        if (ggb_config.material_id) {
            unset(ggb_config, 'customToolBar')
        }

        // Set existing answer
        const base64 = get(this.props.existing_answer, 'data.answer.base64')
        if (base64) {
            ggb_config.ggbBase64 = base64
        }

        this.ggbApp = new GGBApplet(ggb_config, true)
        this.ggbApp.inject(this.uniq_id)
    }

    isValid() {
        if (this.state.answer_option === 'paper') {
            return true
        } else if (this.state.answer_option === 'tool') {
            if (this.graphing_instance) {
                return !!this.graphing_instance.getObjectName(0)
            } else {
                return false
            }
        } else {
            return false
        }
    }

    isCorrect() {
        return true
    }

    isEdited() {
        return true
    }

    isEmpty() {
        return !this.state.answer_option;
    }

    getAnswer() {
        if (this.state.answer_option === 'paper') {
            return {
                answer_option: 'paper'
            }
        } else if (this.state.answer_option === 'tool') {
            return {
                answer_option: 'tool',
                latex: getLatex(this.graphing_instance),
                base64: this.graphing_instance.getBase64()
            }
        } else {
            return null
        }
    }

    onSelectAnswerOption() {
        return (answer_option) => {
            this.setState({
                answer_option
            })
            analytic.log('graphingAnswerOption', answer_option)
        }
    }

    renderOptionsContainer() {
        return (
            <AnswerOptions
                answer_option={this.state.answer_option}
                onSelect={this.onSelectAnswerOption()}
            />
        )
    }

    renderPaper() {
        return (
            <div style={{display: this.state.answer_option === 'paper' ? 'block' : 'none'}}>
                {`Great! Now start your graph on paper.`}
            </div>
        )
    }

    renderGraphingTool() {
        return (
            <div
                className="component-graphing-content-graph"
                style={{height: this.state.answer_option === 'tool' ? 'auto' : '0'}}
            >
                <div id={this.uniq_id}></div>
            </div>
        )
    }

    render() {
        return (
            <div className="challenge-component-graphing" id={`component-${this.uniq_id}`}>
                {this.renderOptionsContainer()}

                <div
                    className="component-graphing-content-container"
                >
                    {this.renderPaper()}

                    {this.renderGraphingTool()}
                </div>
            </div>
        )
    }
}

Graphing.propTypes = {
    component_data: PropTypes.object.isRequired,
    existing_answer: PropTypes.object,
    is_preview: PropTypes.bool.isRequired
}

export default Graphing
